import { Box } from "@mui/material";

export const AppImage = (
  /**
   * @type {import('react').ComponentProps<'img'> & {
   * sx?: import('@mui/system').SxProps;
   * }}
   */
  props
) => (
  <Box
    component="img"
    {...props}
    src={
      props.src?.startsWith("http") || props.src?.startsWith("data")
        ? props.src
        : // eslint-disable-next-line no-undef
          `${
            process.env.REACT_APP_IMAGE_BASE_URL ||
            "https://ritz.locit.com.br/assets/uploads/ecomm"
          }/${props.src}`
    }
  />
);
